import PageContainer                         from '@/components/pageContainer/PageContainer';
import PageTitle                             from '@/components/pageTitle/PageTitle';
import { Box }                               from '@chakra-ui/react';
import { useTranslation }                    from 'react-i18next';
import EntitiesListBox                       from '@/pages/Entity/components/Boxes/EntitiesListBox';

const EntitiesPage = () => {
	const { t } = useTranslation();

	return (
		<PageContainer>
			<Box
				display="flex"
				alignItems="center"
				justifyContent="space-between"
			>
				<PageTitle>
					{t('pages.entities.label')}
				</PageTitle>
			</Box>
			<EntitiesListBox />
		</PageContainer>
		);
}

export default EntitiesPage;